import React from 'react';

import useInterval from '@/hooks/use-interval';

export const steps = [
  { id: 'consolidated', delay: 1750 },
  { id: 'separate', delay: 750 },
  { id: 'labeled', delay: 3000 },
  { id: 'separate', delay: 250 },
];

function useSequence({ mode = 'interval' } = {}) {
  const [stepIndex, setStepIndex] = React.useState(0);

  const step = steps[stepIndex];

  useInterval(
    () => {
      setStepIndex((stepIndex + 1) % steps.length);
    },
    mode === 'interval' ? step.delay : null
  );

  const handlers = {};

  React.useEffect(() => {
    if (mode !== 'interactive') {
      return;
    }

    let timeoutId;

    const step = steps[stepIndex];

    if (stepIndex === 1 || stepIndex === 3) {
      timeoutId = window.setTimeout(() => {
        setStepIndex((stepIndex + 1) % steps.length);
      }, step.delay);
    }

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [mode, stepIndex]);

  if (mode === 'interactive') {
    handlers.onMouseEnter = (ev) => {
      setStepIndex(1);
    };
    handlers.onMouseLeave = (ev) => {
      setStepIndex(3);
    };
    handlers.onFocus = handlers.onMouseEnter;
    handlers.onBlur = handlers.onMouseLeave;
  }

  return [stepIndex, step, handlers];
}

export default useSequence;
